'use client'
import React from 'react'
import * as BlazeSDK from '@wscsports/blaze-web-sdk'
import { WSC_PRESETS, WIDGET_KIND, SKELETON_SHAPE, GRID_ITEM_WIDTH, GRID_GAP } from '../presets'

import classNames from 'classnames'
import classes from './styles.module.scss'

interface WSCPlaceholderProps {
  preset: BlazeSDK.ThemeType
  items: number
  hideTitle?: boolean
}

const GRID_MAX_ITEMS: Record<2 | 3, number> = {
  2: 6,
  3: 9,
}

export const WSCPlaceholder: React.FC<WSCPlaceholderProps> = (props) => {
  const { preset, items, hideTitle } = props
  const config = WSC_PRESETS[preset]
  const { skeletonShape, widgetKind, gridColumns, showLabel } = config

  const isGrid = widgetKind === WIDGET_KIND.GRID
  const isRow = widgetKind === WIDGET_KIND.ROW
  const itemCount = isGrid && gridColumns
    ? Math.min(items, GRID_MAX_ITEMS[gridColumns])
    : items

  const itemWidth = GRID_ITEM_WIDTH[skeletonShape]
  const gridStyle = isGrid && gridColumns && itemWidth
    ? { maxWidth: `${gridColumns * itemWidth + (gridColumns - 1) * GRID_GAP}px` }
    : undefined

  return (
    <div className={classes.container}>
      {!hideTitle && <h2 className={classes.title} />}
      <div
        className={classNames({
          [classes.items]: isRow,
          [classes[`items__row-${skeletonShape}`]]: isRow,
          [classes.items__grid]: isGrid,
          [classes['items__grid--2']]: isGrid && gridColumns === 2,
          [classes['items__grid--3']]: isGrid && gridColumns === 3,
        })}
        style={gridStyle}
      >
        {Array.from({ length: itemCount }).map((_, index) => (
          <div key={index} className={classes.item}>
            <div className={classNames({
              [classes.placeholder]: true,
              [classes.placeholder__circle]: skeletonShape === SKELETON_SHAPE.CIRCLE,
              [classes.placeholder__portrait]: skeletonShape === SKELETON_SHAPE.PORTRAIT,
              [classes.placeholder__landscape]: skeletonShape === SKELETON_SHAPE.LANDSCAPE,
            })} />
            {showLabel && <div className={classes.placeholder__label} />}
          </div>
        ))}
      </div>
    </div>
  )
}
